import { EmptySection } from './empty-section';

export class PlantlifeEmptySection extends EmptySection {}
